// extracted by mini-css-extract-plugin
module.exports = {"figure":"styles_figure__35uEK","postImage":"styles_postImage___wYNQ","caption":"styles_caption__TpyqI"};